<template>
  <expandable-material-card
    :title="$t('components.portal.portal_settings.content')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="sticky_note_2"
  >
    <v-card-text>
      <v-form v-model="valid" v-if="portal !== null && portal !== undefined">
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="
                $t(
                  'components.portal.portal_settings.show_certificate_label_as'
                )
              "
              v-model="portal.showCertificateLabelAs"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="
                $t(
                  'components.portal.portal_settings.show_member_group_label_as'
                )
              "
              v-model="portal.showMemberGroupLabelAs"
              clearable
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <trans-textarea
              :value.sync="portal.memberValidateTooltip"
              :label="
                $t('components.portal.portal_settings.member_validate_tooltip')
              "
              clearable
            ></trans-textarea>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <trans-textarea
              :value.sync="portal.claimsHistoryNote"
              :label="
                $t('components.portal.portal_settings.claims_history_note')
              "
              :capsOn="true"
              clearable
            ></trans-textarea>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <trans-textarea
              :value.sync="portal.benefitsBalanceNote"
              :label="
                $t('components.portal.portal_settings.benefit_balance_note')
              "
              :capsOn="true"
              clearable
            ></trans-textarea>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <trans-textarea
              :value.sync="portal.HSAnote"
              :label="$t('components.portal.plan_settings.hsa_note')"
              clearable
            ></trans-textarea>
          </v-col>
        </v-layout>
        <v-layout row wrap>
          <v-col cols="12" sm="12" md="6" class="pt-0 pb-0">
            <trans-text-editor
              :value.sync="portal.dependantDefinition"
              :label="
                $t('components.portal.portal_settings.dependant_definition')
              "
            ></trans-text-editor>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="pt-0 pb-0">
            <trans-text-editor
              :value.sync="portal.drugExceptionNote"
              :label="
                $t('components.portal.portal_settings.drug_exception_note')
              "
            ></trans-text-editor>
          </v-col>
          <template
            v-if="
              portal.benefitCardsNote !== null &&
                portal.benefitCardsNote !== undefined
            "
          >
            <v-col
              cols="12"
              sm="12"
              md="6"
              class="pt-0 pb-0"
              v-for="key in Object.keys(portal.benefitCardsNote)"
              :key="key"
            >
              <trans-textarea
                :value.sync="portal.benefitCardsNote[key]"
                :label="
                  $t(
                    'components.portal.portal_settings_card.benefit_cards_note_{0}',
                    [portal.benefitCardsNote[key].type]
                  )
                "
                clearable
              ></trans-textarea>
            </v-col>
          </template>
        </v-layout>
        <v-layout row wrap>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="pt-0 pb-0"
            v-if="portal.hasProviderSearch"
          >
            <trans-text-editor
              :value.sync="portal.providerSearchNote"
              :rules="[$rules.required]"
              class="required"
              :label="
                $t('components.portal.portal_settings.provider_search_note')
              "
            ></trans-text-editor>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            class="pt-0 pb-0"
            v-if="portal.hasDrugSearch"
          >
            <trans-text-editor
              :value.sync="portal.drugSearchNote"
              :rules="[$rules.required]"
              class="required"
              :label="$t('components.portal.portal_settings.drug_search_note')"
            ></trans-text-editor>
          </v-col>
        </v-layout>
      </v-form>
    </v-card-text>
  </expandable-material-card>
</template>

<script>
import TransTextarea from "./TransTextarea.vue";
import TransTextEditor from "./TransTextEditor.vue";
import ExpandableMaterialCard from "./ExpandableMaterialCard.vue";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";

export default {
  components: {
    TransTextarea,
    TransTextEditor,
    ExpandableMaterialCard,
    NoAutocompleteTextfield,
  },
  props: ["dataContainer"],
  data() {
    return {
      valid: true,
      portal: null,
    };
  },
  watch: {
    dataContainer: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.portal = JSON.parse(JSON.stringify(v.portal));
        }
      },
    },
    portal: {
      handler(v) {
        this.$emit("update", v);
      },
      deep: true,
    },
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
  },
  mounted() {
    if (this.dataContainer !== null && this.dataContainer !== undefined) {
      this.portal = JSON.parse(JSON.stringify(this.dataContainer.portal));
      this.$nextTick(() => {
        this.$emit("valid", this.valid);
      });
    }
  },
};
</script>
